import { create } from 'zustand';
import type { ActiveTunnel, TunnelStatus } from '@/types';

interface TunnelStore {
  activeTunnels: Record<string, ActiveTunnel>;

  setStatus: (tunnelId: string, status: TunnelStatus, extra?: { localPort?: number; error?: string }) => void;
  removeTunnel: (tunnelId: string) => void;
  isRunning: (tunnelId: string) => boolean;
}

export const useTunnelStore = create<TunnelStore>((set, get) => ({
  activeTunnels: {},

  setStatus: (tunnelId, status, extra) => {
    set((s) => ({
      activeTunnels: {
        ...s.activeTunnels,
        [tunnelId]: {
          tunnelId,
          status,
          localPort: extra?.localPort ?? s.activeTunnels[tunnelId]?.localPort,
          error: extra?.error,
          startedAt: status === 'running' ? new Date().toISOString() : s.activeTunnels[tunnelId]?.startedAt,
        },
      },
    }));
  },

  removeTunnel: (tunnelId) => {
    set((s) => {
      const { [tunnelId]: _, ...rest } = s.activeTunnels;
      return { activeTunnels: rest };
    });
  },

  isRunning: (tunnelId) => {
    return get().activeTunnels[tunnelId]?.status === 'running';
  },
}));
